(function() {

	const toggleClass = 'mobile-nav-open';
	// var openIcon = '<img class="sub-menu__open" src="' + js_vars.template_directory + '/assets/images/add.svg">';

	// jQuery('#menu-main-menu-new .menu-item-has-children').append(openIcon);

	/**
	 * Handle the user clicking on a menu toggle
	 * @param     {MouseEvent} event    An event raised by the user action
	 * @return    {void}
	 */
	document.addEventListener(
		'click',
		function handleToggleClick(event) {
			// Define strings
			const matchesSelector = '[data-action="toggle-mobile-nav"]';

			// Check the element is correct
			if(
				!event.target.matches(matchesSelector) &&
				!event.target.matches(matchesSelector + ' *')
			) {
				return;
			}

			event.preventDefault();

			// Toggle the body class
			document.body.classList.toggle(toggleClass);
		}
	);

	/**
	 * Close the menu when the window resizes
	 */
	window.addEventListener(
		'resize',
		function() {
			document.body.classList.remove(toggleClass);
		},
		{
			passive: true
		}
	);

})();
